function unwrapSpans(element: Element): void {
  const spans = Array.from(element.querySelectorAll('span'));
  spans.forEach(span => {
    const parent = span.parentNode;
    if (parent) {
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    }
  });
}

function unwrapParagraphs(element: Element): void {
  const paragraphs = Array.from(element.querySelectorAll('p'));
  paragraphs.forEach(p => {
    const parent = p.parentNode;
    if (parent) {
      while (p.firstChild) {
        parent.insertBefore(p.firstChild, p);
      }
      parent.removeChild(p);
    }
  });
}

function unwrapRedundantFormatting(element: Element): void {
  const bTags = Array.from(element.querySelectorAll('b'));
  bTags.forEach(b => {
    if (b.children.length === 1 && b.children[0].tagName === 'STRONG') {
      const strong = b.children[0];
      const parent = b.parentNode;
      if (parent) {
        parent.replaceChild(strong, b);
      }
    }
  });

  const strongTags = Array.from(element.querySelectorAll('strong'));
  strongTags.forEach(strong => {
    if (strong.children.length === 1 && strong.children[0].tagName === 'B') {
      const b = strong.children[0];
      const parent = strong.parentNode;
      if (parent) {
        parent.replaceChild(b, strong);
      }
    }
  });
}

export function cleanTableHTML(container: HTMLElement): void {
  const colgroupElements = container.querySelectorAll('colgroup');
  colgroupElements.forEach(colgroup => colgroup.remove());

  const allElements = container.querySelectorAll('*');
  allElements.forEach(element => {
    Array.from(element.attributes).forEach(attr => {
      element.removeAttribute(attr.name);
    });
  });

  const tableElements = container.querySelectorAll('table');
  tableElements.forEach(table => {
    unwrapSpans(table);
    unwrapParagraphs(table);
    unwrapRedundantFormatting(table);
  });
}
